export class StampIds {

    listFlightIdToProcess: number[];
    csvFile: boolean;
    companyCode: String;
    airportIATA: String;

}